export const MOCK_APPRENANTS = [
  // ── TLG PHARMA - Apprenants actifs ─────────────────────────────────────────
  {
    id: 'app-001', profile_id: 'prof-001', parent_id: 'par-001', client_id: 'tlg-001',
    prenom: 'Aminata', nom: 'Koné',
    date_naissance: '2015-03-12', age: 9, tranche_age: 'enfant',
    niveau_cecr: 'A1', groupe_id: 'grp-001', statut: 'actif', points_gamif: 320,
    date_inscription: '2025-09-02',
  },
  {
    id: 'app-002', profile_id: 'prof-002', parent_id: 'par-002', client_id: 'tlg-001',
    prenom: 'Moussa', nom: 'Traoré',
    date_naissance: '2010-07-24', age: 14, tranche_age: 'adolescent',
    niveau_cecr: 'A2', groupe_id: 'grp-002', statut: 'bloque', points_gamif: 150,
    date_inscription: '2025-09-02',
  },
  {
    id: 'app-003', profile_id: 'prof-003', parent_id: 'par-003', client_id: 'tlg-001',
    prenom: 'Fatou', nom: 'Diallo',
    date_naissance: '2013-11-05', age: 11, tranche_age: 'enfant',
    niveau_cecr: 'A1', groupe_id: 'grp-001', statut: 'actif', points_gamif: 480,
    date_inscription: '2025-09-02',
  },
  {
    id: 'app-004', profile_id: 'prof-004', parent_id: 'par-004', client_id: 'tlg-001',
    prenom: 'Ibrahim', nom: 'Coulibaly',
    date_naissance: '2009-02-18', age: 15, tranche_age: 'adolescent',
    niveau_cecr: 'B1', groupe_id: 'grp-003', statut: 'actif', points_gamif: 90,
    date_inscription: '2025-09-10',
  },
  {
    id: 'app-008', profile_id: 'prof-008', parent_id: 'par-005', client_id: 'tlg-001',
    prenom: 'Lamine', nom: 'Coulibaly',
    date_naissance: '2016-09-03', age: 8, tranche_age: 'enfant',
    niveau_cecr: 'A2', groupe_id: 'grp-001', statut: 'actif', points_gamif: 210,
    date_inscription: '2025-10-01',
  },

  // ── ORANGE CI - Apprenants actifs ──────────────────────────────────────────
  {
    id: 'app-009', profile_id: 'prof-009', parent_id: 'par-006', client_id: 'oc-001',
    prenom: 'Stella', nom: 'Kouassi',
    date_naissance: '2014-04-22', age: 10, tranche_age: 'enfant',
    niveau_cecr: 'A1', groupe_id: 'grp-004', statut: 'actif', points_gamif: 165,
    date_inscription: '2025-11-03',
  },
  {
    id: 'app-010', profile_id: 'prof-010', parent_id: 'par-007', client_id: 'oc-001',
    prenom: 'Karim', nom: 'Ouédraogo',
    date_naissance: '2011-12-11', age: 13, tranche_age: 'adolescent',
    niveau_cecr: 'B1', groupe_id: 'grp-005', statut: 'actif', points_gamif: 540,
    date_inscription: '2025-11-03',
  },

  // ── SGBCI - Apprenants actifs ───────────────────────────────────────────────
  {
    id: 'app-011', profile_id: 'prof-011', parent_id: 'par-008', client_id: 'sg-001',
    prenom: 'Éric', nom: 'Yao',
    date_naissance: '2013-06-30', age: 11, tranche_age: 'enfant',
    niveau_cecr: 'A2', groupe_id: 'grp-006', statut: 'actif', points_gamif: 310,
    date_inscription: '2026-01-15',
  },
  {
    id: 'app-012', profile_id: 'prof-012', parent_id: 'par-009', client_id: 'sg-001',
    prenom: 'Franck', nom: 'Kra',
    date_naissance: '2015-08-17', age: 9, tranche_age: 'enfant',
    niveau_cecr: 'A1', groupe_id: 'grp-006', statut: 'actif', points_gamif: 85,
    date_inscription: '2026-01-15',
  },

  // ── Adulte / Employé TLG PHARMA ───────────────────────────────────────────
  {
    id: 'app-adulte-001', profile_id: 'prof-adulte-001', parent_id: null, client_id: 'tlg-001',
    prenom: 'Kofi', nom: 'Asante',
    date_naissance: '1992-03-15', age: 34, tranche_age: 'adulte',
    niveau_cecr: 'A2', groupe_id: 'grp-002', statut: 'actif', points_gamif: 620,
    poste: 'Responsable Logistique', departement: 'Supply Chain',
    date_inscription: '2025-09-02',
  },

  // ── Particuliers actifs ────────────────────────────────────────────────────
  {
    id: 'app-013', profile_id: 'prof-013', parent_id: 'par-010', client_id: null,
    prenom: 'Yasmine', nom: 'Diallo',
    date_naissance: '2012-02-28', age: 12, tranche_age: 'enfant',
    niveau_cecr: 'A2', groupe_id: 'grp-001', statut: 'actif', points_gamif: 430,
    date_inscription: '2026-02-10',
  },

  // ── En attente de test de niveau (arrivés via Onboarding) ─────────────────
  {
    id: 'app-005', profile_id: 'prof-005', parent_id: 'par-001', client_id: 'tlg-001',
    prenom: 'Kofi', nom: 'Assi',
    date_naissance: '2016-04-10', age: 10, tranche_age: 'enfant',
    niveau_cecr: null, groupe_id: null,
    statut: 'test_niveau_pending', points_gamif: 0,
    date_inscription: '2026-05-20',
  },
  {
    id: 'app-006', profile_id: 'prof-006', parent_id: 'par-002', client_id: 'tlg-001',
    prenom: 'Awa', nom: 'Bamba',
    date_naissance: '2011-08-22', age: 13, tranche_age: 'adolescent',
    niveau_cecr: null, groupe_id: null,
    statut: 'test_niveau_pending', points_gamif: 0,
    date_inscription: '2026-05-28',
  },
  {
    id: 'app-007', profile_id: 'prof-007', parent_id: 'par-001', client_id: 'tlg-001',
    prenom: 'Chloé', nom: 'Mensah',
    date_naissance: '2017-01-15', age: 7, tranche_age: 'enfant',
    niveau_cecr: null, groupe_id: null,
    statut: 'en_attente', points_gamif: 0,
    date_inscription: '2026-06-01',
  },
  {
    id: 'app-014', profile_id: 'prof-014', parent_id: 'par-011', client_id: 'oc-001',
    prenom: 'Nadia', nom: 'Touré',
    date_naissance: '2008-05-14', age: 16, tranche_age: 'adolescent',
    niveau_cecr: null, groupe_id: null,
    statut: 'en_attente', points_gamif: 0,
    date_inscription: '2026-06-03',
  },
  {
    id: 'app-015', profile_id: 'prof-015', parent_id: 'par-012', client_id: 'sg-001',
    prenom: 'Ibrahim', nom: 'Sanogo',
    date_naissance: '2009-11-01', age: 15, tranche_age: 'adolescent',
    niveau_cecr: null, groupe_id: null,
    statut: 'en_attente', points_gamif: 0,
    date_inscription: '2026-04-14',
  },
  {
    id: 'app-016', profile_id: 'prof-016', parent_id: 'par-013', client_id: null,
    prenom: 'Chloé', nom: 'Mensah',
    date_naissance: '2017-03-22', age: 7, tranche_age: 'enfant',
    niveau_cecr: null, groupe_id: null,
    statut: 'en_attente', points_gamif: 0,
    date_inscription: '2026-06-05',
  },

  // ── Cours particuliers (privés) actifs ────────────────────────────────────
  {
    id: 'prv-001', profile_id: 'prf-prv-001', parent_id: 'par-p01', client_id: null,
    prenom: 'Adja', nom: 'Bah',
    date_naissance: '2013-05-10', age: 11, tranche_age: 'enfant',
    niveau_cecr: 'A1', groupe_id: null, statut: 'actif', points_gamif: 195,
    cours_prive: true, professeur_id: 'teacher-001',
    date_inscription: '2026-03-05',
  },
  {
    id: 'prv-002', profile_id: 'prf-prv-002', parent_id: 'par-p02', client_id: null,
    prenom: 'Sékou', nom: 'Camara',
    date_naissance: '2010-11-22', age: 14, tranche_age: 'adolescent',
    niveau_cecr: 'B1', groupe_id: null, statut: 'actif', points_gamif: 410,
    cours_prive: true, professeur_id: 'teacher-002',
    date_inscription: '2026-01-20',
  },
  {
    id: 'prv-003', profile_id: 'prf-prv-003', parent_id: 'par-p03', client_id: null,
    prenom: 'Marième', nom: 'Sow',
    date_naissance: '2015-02-14', age: 9, tranche_age: 'enfant',
    niveau_cecr: 'A1', groupe_id: null, statut: 'actif', points_gamif: 88,
    cours_prive: true, professeur_id: 'teacher-001',
    date_inscription: '2026-02-18',
  },
  {
    id: 'prv-004', profile_id: 'prf-prv-004', parent_id: 'par-p04', client_id: null,
    prenom: 'Mamoudou', nom: 'Baldé',
    date_naissance: '2007-09-03', age: 17, tranche_age: 'adolescent',
    niveau_cecr: 'B2', groupe_id: null, statut: 'actif', points_gamif: 730,
    cours_prive: true, professeur_id: 'teacher-002',
    date_inscription: '2025-10-12',
  },
  {
    id: 'prv-005', profile_id: 'prf-prv-005', parent_id: 'par-p05', client_id: null,
    prenom: 'Ramatou', nom: 'Barry',
    date_naissance: '2014-07-28', age: 10, tranche_age: 'enfant',
    niveau_cecr: 'A2', groupe_id: null, statut: 'actif', points_gamif: 260,
    cours_prive: true, professeur_id: 'teacher-003',
    date_inscription: '2026-04-07',
  },
  {
    id: 'prv-006', profile_id: 'prf-prv-006', parent_id: 'par-p06', client_id: null,
    prenom: 'Ibrahima', nom: 'Kouyaté',
    date_naissance: '2011-04-16', age: 13, tranche_age: 'adolescent',
    niveau_cecr: 'A2', groupe_id: null, statut: 'bloque', points_gamif: 140,
    cours_prive: true, professeur_id: 'teacher-001',
    date_inscription: '2026-03-22',
  },
  {
    id: 'prv-007', profile_id: 'prf-prv-007', parent_id: 'par-p07', client_id: null,
    prenom: 'Oumou', nom: 'Diakité',
    date_naissance: '2016-12-01', age: 8, tranche_age: 'enfant',
    niveau_cecr: 'A1', groupe_id: null, statut: 'actif', points_gamif: 55,
    cours_prive: true, professeur_id: 'teacher-003',
    date_inscription: '2026-05-10',
  },
  {
    id: 'prv-008', profile_id: 'prf-prv-008', parent_id: 'par-p08', client_id: null,
    prenom: 'Alpha', nom: 'Condé',
    date_naissance: '2008-06-19', age: 16, tranche_age: 'adolescent',
    niveau_cecr: 'C1', groupe_id: null, statut: 'actif', points_gamif: 1120,
    cours_prive: true, professeur_id: 'teacher-002',
    date_inscription: '2025-12-01',
  },
  {
    id: 'prv-009', profile_id: 'prf-prv-009', parent_id: 'par-p09', client_id: null,
    prenom: 'Fanta', nom: 'Sylla',
    date_naissance: '2013-03-07', age: 11, tranche_age: 'enfant',
    niveau_cecr: 'A2', groupe_id: null, statut: 'actif', points_gamif: 330,
    cours_prive: true, professeur_id: 'teacher-001',
    date_inscription: '2026-05-15',
  },
  {
    id: 'prv-010', profile_id: 'prf-prv-010', parent_id: 'par-p10', client_id: null,
    prenom: 'Aissatou', nom: 'Keita',
    date_naissance: '2009-10-25', age: 15, tranche_age: 'adolescent',
    niveau_cecr: 'B1', groupe_id: null, statut: 'actif', points_gamif: 570,
    cours_prive: true, professeur_id: 'teacher-002',
    date_inscription: '2026-04-28',
  },
  {
    id: 'prv-011', profile_id: 'prf-prv-011', parent_id: 'par-p11', client_id: null,
    prenom: 'Mohamed', nom: 'Traoré',
    date_naissance: '2012-08-31', age: 12, tranche_age: 'enfant',
    niveau_cecr: 'A1', groupe_id: null, statut: 'en_attente', points_gamif: 0,
    cours_prive: true, professeur_id: null,
    date_inscription: '2026-06-08',
  },
  {
    id: 'prv-012', profile_id: 'prf-prv-012', parent_id: 'par-p12', client_id: null,
    prenom: 'Kadiatou', nom: 'Diallo',
    date_naissance: '2006-01-13', age: 18, tranche_age: 'adulte',
    niveau_cecr: 'B2', groupe_id: null, statut: 'actif', points_gamif: 850,
    cours_prive: true, professeur_id: 'teacher-003',
    date_inscription: '2025-11-18',
  },
  {
    id: 'prv-013', profile_id: 'prf-prv-013', parent_id: 'par-p13', client_id: null,
    prenom: 'Lansana', nom: 'Koroma',
    date_naissance: '2015-06-05', age: 9, tranche_age: 'enfant',
    niveau_cecr: 'A1', groupe_id: null, statut: 'actif', points_gamif: 115,
    cours_prive: true, professeur_id: 'teacher-001',
    date_inscription: '2026-05-02',
  },
  {
    id: 'prv-014', profile_id: 'prf-prv-014', parent_id: 'par-p14', client_id: null,
    prenom: 'Bineta', nom: 'Fall',
    date_naissance: '2011-02-17', age: 13, tranche_age: 'adolescent',
    niveau_cecr: 'B1', groupe_id: null, statut: 'actif', points_gamif: 445,
    cours_prive: true, professeur_id: 'teacher-002',
    date_inscription: '2026-06-09',
  },
  {
    id: 'prv-015', profile_id: 'prf-prv-015', parent_id: 'par-p15', client_id: null,
    prenom: 'Souleymane', nom: 'Ndiaye',
    date_naissance: '2007-04-30', age: 17, tranche_age: 'adolescent',
    niveau_cecr: 'C1', groupe_id: null, statut: 'actif', points_gamif: 990,
    cours_prive: true, professeur_id: 'teacher-003',
    date_inscription: '2026-06-10',
  },
];

export const MOCK_PROFIL_APPRENANT = MOCK_APPRENANTS[0];

export const MOCK_PARENTS = [
  { id:'par-001', prenom:'Djeneba',  nom:'Koné',     email:'djeneba.kone@tlgpharma.com',      telephone:'+225 07 12 34 56', role:'parent' },
  { id:'par-002', prenom:'Seydou',   nom:'Traoré',   email:'seydou.traore@tlgpharma.com',     telephone:'+225 05 98 76 54', role:'parent' },
  { id:'par-003', prenom:'Mariam',   nom:'Diallo',   email:'mariam.diallo@tlgpharma.com',     telephone:'+225 01 11 22 33', role:'parent' },
  { id:'par-004', prenom:'Mamadou',  nom:'Coulibaly',email:'mamadou.coulibaly@tlgpharma.com', telephone:'+225 07 44 55 66', role:'parent' },
  { id:'par-005', prenom:'Mariam',   nom:'Coulibaly',email:'mariam.coulibaly@tlgpharma.com',  telephone:'+225 01 77 88 99', role:'parent' },
  { id:'par-006', prenom:'Jean',     nom:'Kouassi',  email:'jean.kouassi@orange.ci',          telephone:'+225 07 99 88 77', role:'parent' },
  { id:'par-007', prenom:'Awa',      nom:'Ouédraogo',email:'awa.ouedraogo@orange.ci',         telephone:'+225 05 22 33 44', role:'parent' },
  { id:'par-008', prenom:'Akissi',   nom:'Yao',      email:'akissi.yao@sgbci.ci',             telephone:'+225 07 20 30 40', role:'parent' },
  { id:'par-009', prenom:'Adèle',    nom:'Kra',      email:'adele.kra@sgbci.ci',              telephone:'+225 05 80 90 11', role:'parent' },
  { id:'par-010', prenom:'Boubacar', nom:'Diallo',   email:'b.diallo@hotmail.com',            telephone:'+225 01 66 77 88', role:'parent' },
  { id:'par-011', prenom:'Oumar',    nom:'Touré',    email:'oumar.toure@sgbci.ci',            telephone:'+225 01 50 60 70', role:'parent' },
  { id:'par-012', prenom:'Fatouma', nom:'Sanogo',   email:'fatouma.sanogo@yahoo.fr',         telephone:'+225 05 33 44 55', role:'parent' },
  { id:'par-013', prenom:'Koffi',    nom:'Mensah',   email:'koffi.mensah@gmail.com',          telephone:'+225 07 00 11 22', role:'parent' },
];
